// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f2a780fc","703":"6a34baf2","787":"2bd44167","880":"4cdb7bba"}[chunkId] + ".chunk.js";
};